import script from "./HomeDoctorComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeDoctorComponent.vue?vue&type=script&setup=true&lang=js"

import "./HomeDoctorComponent.vue?vue&type=style&index=0&id=90c56a80&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-morula\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90c56a80"]])

export default __exports__